import { Tooltip } from "@blueprintjs/core";
import autobind from 'autobind-decorator';
import React from "react";

import { FlexJustify } from "common/fragments/Flex";
import { BoxView } from "common/views/box/Box.view";
import { CardView } from 'common/views/card/Card.view';
import HeadingView from "common/views/heading/Heading.view";
import IconView from "common/views/icon/Icon.view";
import { RowsView } from "common/views/rows/Rows.view";
import { IQueryOne, QueryOne } from "core/api/query";
import DateLabel from "core/components/label/DateLabel";
import { IPanelProps, Panel } from "core/decorators/Panel";
import OrganizationProducts from "panels/organizations/admin/entities/OrganizationProducts";
import Config from "./Config";
import labelProvider from './OrganizationProducts.labels';

const { Labels } = labelProvider;

@Panel({id: "organizations-admin-products", configClass: Config, pageParams: true})
@QueryOne(OrganizationProducts, {}, true)
export default class OrganizationsProducts extends React.PureComponent<IPanelProps<Config> & IQueryOne<OrganizationProducts>> {

	@autobind
	public getQueryParams(): object {
			return {guid: this.props.pageParams.guid};
	}

	public render() {
		const { config, entity } = this.props;

		const userCards = (entity && entity.entryList) && this.props.entity.entryList.map((entry, index) => {
			const { product } = entry;
			const src: string = product.smallIconURL;

			const actions: any[] = [
				{
					text: <Labels.LaunchCourse/>,
					icon: "play",
					onClick: () => alert(`Launching ${name}!`)
				}
			];
			const enrollLimitView = entry.enrollLimit == null || entry.enrollLimit < 1 ? <IconView icon="blank" viewKey="no-enroll-limit" /> : entry.enrollLimit;

			const itemViewProps = { actions };

			const start = entry.startDate && (
				<Tooltip content="Release date of this course.">
					<IconView icon="calendar" viewKey="startdate">
						<DateLabel value={entry.startDate} />
					</IconView>
				</Tooltip>
			);

			const end = entry.endDate && (
				<Tooltip content="Last date that this course will be available.">
					<IconView icon="calendar" viewKey="enddate">
						<DateLabel value={entry.endDate} />
					</IconView>
				</Tooltip>
			);

			const enrollment = entry.enrollCount && (
				<Tooltip content="User in your organization that are enrolled / enroll limit">
					<IconView icon="user" viewKey="enrollment">{entry.enrollCount} / {enrollLimitView}</IconView>
				</Tooltip>
			);

			return(
				<CardView viewKey="list-body" key={index}>
					<FlexJustify>
						<div>
							<HeadingView viewKey="product-name">{product.name}</HeadingView>
						</div>

						<div>
							{start}
							{end}
							{enrollment}
						</div>
					</FlexJustify>
				</CardView>
			);
		});

		return (

			<BoxView title={config.title} viewKey="organization-userlist-box">
				<RowsView viewKey="organization-userlist-rows">
					{userCards}
				</RowsView>
			</BoxView>
		);
	}
}



// WEBPACK FOOTER //
// ./src/panels/organizations/admin/OrganizationProducts.panel.tsx